import statementService from './statementService';

export * from './types';
export default statementService;



// WEBPACK FOOTER //
// ./src/services/statement/index.ts